import { useEffect } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { UNACKNOWLEDGED_UPDATES_QUERY_KEY } from 'shared/api/productUpdatesApi/requests/getNewUpdates/getNewUpdates'
import { logger } from 'shared/services/logger'
import { subscribeToProductUpdatesChannel } from 'shared/services/productUpdatesSocket'

import { useUserContext } from './useUserContext'

// Listen to the user's product-updates channel and refetch pending materials when
// a material is published, so the ProductUpdates modal appears in real time instead
// of waiting for the next poll (window focus / route change).
export const useProductUpdatesSocket = () => {
  const { user } = useUserContext()
  const userId = user?.id
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!userId) {
      return
    }

    return subscribeToProductUpdatesChannel(
      `product-updates.user.${userId}`,
      eventName => {
        logger.track('product_updates.published_by_socket', {
          event: eventName
        })
        queryClient.invalidateQueries({
          queryKey: [UNACKNOWLEDGED_UPDATES_QUERY_KEY]
        })
      }
    )
  }, [userId, queryClient])
}
